import { Component, HostBinding, Input, OnChanges, SimpleChanges } from "@angular/core";
import "./veriInfoPanel.component.scss";

@Component({
    selector: "veri-info-panel",
    template: require("./veriInfoPanel.component.html")
})
export class VeriInfoPanelComponent implements OnChanges {

    @Input() title: string;
    @Input() tinyMode: boolean;

    @HostBinding("class.has-icon") @Input() icon: string;
    @HostBinding("class.warning") @Input() warning: boolean;
    @HostBinding("class.good") @Input() good: boolean;
    @HostBinding("class.transparent") @Input() transparent: boolean;

    // --

    isFontAwesome = false;

    constructor() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["icon"]) {
            this.isFontAwesome = this.icon.indexOf("fa-") == 0;

            // Auto add fa-solid if not set
            if (this.isFontAwesome && this.icon.split("fa-").length == 2) {
                this.icon += " fa-solid";
            };
        }
    }
}
